import { render } from "./your-profile-component.vue?vue&type=template&id=631d95e4&scoped=true"
import script from "./your-profile-component.vue?vue&type=script&lang=js"
export * from "./your-profile-component.vue?vue&type=script&lang=js"

import "./your-profile-component.vue?vue&type=style&index=0&id=631d95e4&scoped=true&lang=scss"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-631d95e4"]])

export default __exports__